export interface IUser {
  internal_id: string;
  createdAt: string;
  email: string[];
  role: UserRole;
  profiles: Profile[];
  uid: string[];
  isSubscribedToEmail: boolean;
  subscription?: ISubscription;
}

export interface ISubscription {
  expirablePoints: number;
}

export interface IUserWithMeta {
  data: IUser[];
  total: number;
}

export interface Profile {
  uid: string;
  name: string;
  createdAt: string;
  profileImg: string;
  birthday: string;
  profileDifficulties: ProfileDifficulties[];
}

export enum UserRole {
  free = "free",
  premium = "premium",
  premiumUnlimited = "premiumUnlimited",
  banned = "banned",
  admin = "administrator",
}

export type ProfileDifficulties = {
  category: Category;
  difficulty: LevelDifficulty;
  uid: string;
};

export enum Category {
  MightyMe = "Mighty Me",
  MadScientist = "Mad Scientist",
  NumberWizardry = "Number Wizardry",
  ReadingWonderland = "Reading Wonderland",
  GeoExplorers = "Geo Explorers",
}

export enum LevelDifficulty {
  EASY = "Easy",
  MEDIUM = "Medium",
  HARDCORE = "Hardcore",
}

export interface IUpdateUserRequest {
  uid: string;
  role?: UserRole;
  expirablePoints?: number;
}
export interface ICreateAdminRequest {
  emails: string[];
  status?: string;
}

export const getToken = () => {
  const tokenString = localStorage.getItem("token") || "";
  return {
    token: tokenString,
  };
};
